import { __assign, __awaiter, __generator, __rest } from "tslib";
import { Track } from './Track';
export function getError(e) {
    return e instanceof Error
        ? { message: e.message || '', stack: e.stack || '' }
        : e;
}
export function TrackApiError(_a) {
    var _b = _a.screen, screen = _b === void 0 ? '' : _b, _c = _a.version, version = _c === void 0 ? '' : _c, _d = _a.projectKey, projectKey = _d === void 0 ? '' : _d, _e = _a.ratAccountId, ratAccountId = _e === void 0 ? '' : _e, _f = _a.ratServiceType, ratServiceType = _f === void 0 ? '' : _f, _g = _a.ratServiceId, ratServiceId = _g === void 0 ? '' : _g, _h = _a.isMobile, isMobile = _h === void 0 ? false : _h, _j = _a.error, error = _j === void 0 ? '' : _j, _k = _a.userId, userId = _k === void 0 ? '' : _k, _l = _a.sessionId, sessionId = _l === void 0 ? '' : _l, _m = _a.domainScopedSessionId, domainScopedSessionId = _m === void 0 ? '' : _m, _o = _a.clientId, clientId = _o === void 0 ? '' : _o, ratApiAccountSrc = _a.ratApiAccountSrc, _p = _a.isPreview, isPreview = _p === void 0 ? false : _p;
    return Track({
        screen: screen,
        action: 'ERROR',
        version: version,
        projectKey: projectKey,
        ratAccountId: ratAccountId,
        ratServiceType: ratServiceType,
        ratServiceId: ratServiceId,
        isMobile: isMobile,
        message: getError(error),
        userId: userId,
        sessionId: sessionId,
        domainScopedSessionId: domainScopedSessionId,
        clientId: clientId,
        ratApiAccountSrc: ratApiAccountSrc,
        isPreview: isPreview,
    });
}
export function TrackApiNoResponse(_a) {
    var _b = _a.version, version = _b === void 0 ? '' : _b, _c = _a.projectKey, projectKey = _c === void 0 ? '' : _c, _d = _a.ratAccountId, ratAccountId = _d === void 0 ? '' : _d, _e = _a.ratServiceType, ratServiceType = _e === void 0 ? '' : _e, _f = _a.ratServiceId, ratServiceId = _f === void 0 ? '' : _f, _g = _a.isMobile, isMobile = _g === void 0 ? false : _g, _h = _a.userId, userId = _h === void 0 ? '' : _h, _j = _a.sessionId, sessionId = _j === void 0 ? '' : _j, _k = _a.domainScopedSessionId, domainScopedSessionId = _k === void 0 ? '' : _k, _l = _a.clientId, clientId = _l === void 0 ? '' : _l, ratApiAccountSrc = _a.ratApiAccountSrc, _m = _a.isPreview, isPreview = _m === void 0 ? false : _m;
    return Track({
        screen: 'MESSAGE_API',
        action: 'NO_RESPONSE',
        version: version,
        projectKey: projectKey,
        ratAccountId: ratAccountId,
        ratServiceType: ratServiceType,
        ratServiceId: ratServiceId,
        isMobile: isMobile,
        userId: userId,
        sessionId: sessionId,
        domainScopedSessionId: domainScopedSessionId,
        clientId: clientId,
        ratApiAccountSrc: ratApiAccountSrc,
        isPreview: isPreview,
    });
}
export function TrackApiSuccess(_a) {
    var data = _a.data, rest = __rest(_a, ["data"]);
    return Track(__assign({ action: 'SUCCESS', message: data }, rest));
}
export function TrackApiNotValid(_a) {
    var _b = _a.screen, screen = _b === void 0 ? '' : _b, _c = _a.version, version = _c === void 0 ? '' : _c, _d = _a.projectKey, projectKey = _d === void 0 ? '' : _d, _e = _a.ratAccountId, ratAccountId = _e === void 0 ? '' : _e, _f = _a.ratServiceType, ratServiceType = _f === void 0 ? '' : _f, _g = _a.ratServiceId, ratServiceId = _g === void 0 ? '' : _g, _h = _a.data, data = _h === void 0 ? [] : _h, _j = _a.isMobile, isMobile = _j === void 0 ? false : _j, _k = _a.userId, userId = _k === void 0 ? '' : _k, _l = _a.sessionId, sessionId = _l === void 0 ? '' : _l, _m = _a.domainScopedSessionId, domainScopedSessionId = _m === void 0 ? '' : _m, _o = _a.clientId, clientId = _o === void 0 ? '' : _o, ratApiAccountSrc = _a.ratApiAccountSrc, _p = _a.isPreview, isPreview = _p === void 0 ? false : _p;
    return Track({
        screen: screen,
        action: 'NOT_VALID',
        version: version,
        projectKey: projectKey,
        ratAccountId: ratAccountId,
        ratServiceType: ratServiceType,
        ratServiceId: ratServiceId,
        message: data,
        isMobile: isMobile,
        userId: userId,
        sessionId: sessionId,
        domainScopedSessionId: domainScopedSessionId,
        clientId: clientId,
        ratApiAccountSrc: ratApiAccountSrc,
        isPreview: isPreview,
    });
}
export function TrackWithCb(_a) {
    var trackCb = _a.trackCb, screen = _a.screen, action = _a.action, _b = _a.version, version = _b === void 0 ? '' : _b, _c = _a.projectKey, projectKey = _c === void 0 ? '' : _c, campaignId = _a.campaignId, contentId = _a.contentId, correlationId = _a.correlationId, replacementId = _a.replacementId, selector = _a.selector, impressionId = _a.impressionId, _d = _a.ratAccountId, ratAccountId = _d === void 0 ? '' : _d, _e = _a.ratServiceType, ratServiceType = _e === void 0 ? '' : _e, _f = _a.ratServiceId, ratServiceId = _f === void 0 ? '' : _f, _g = _a.isMobile, isMobile = _g === void 0 ? false : _g, _h = _a.message, message = _h === void 0 ? '' : _h, _j = _a.userId, userId = _j === void 0 ? '' : _j, _k = _a.sessionId, sessionId = _k === void 0 ? '' : _k, _l = _a.domainScopedSessionId, domainScopedSessionId = _l === void 0 ? '' : _l, _m = _a.clientId, clientId = _m === void 0 ? '' : _m, ratApiAccountSrc = _a.ratApiAccountSrc, _o = _a.isPreview, isPreview = _o === void 0 ? false : _o;
    return __awaiter(this, void 0, void 0, function () {
        var opts, ratResult, e_1;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    opts = {
                        version: version,
                        projectKey: projectKey,
                        screen: screen,
                        campaignId: campaignId,
                        correlationId: correlationId,
                        contentId: contentId,
                        replacementId: replacementId,
                        selector: selector,
                        impressionId: impressionId,
                        ratAccountId: ratAccountId,
                        ratServiceType: ratServiceType,
                        ratServiceId: ratServiceId,
                        isMobile: isMobile,
                        userId: userId,
                        sessionId: sessionId,
                        domainScopedSessionId: domainScopedSessionId,
                        clientId: clientId,
                        ratApiAccountSrc: ratApiAccountSrc,
                        isPreview: isPreview,
                    };
                    _p.label = 1;
                case 1:
                    _p.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all([
                            Track(__assign(__assign({}, opts), { action: action, message: message })),
                            trackCb(),
                        ])];
                case 2:
                    ratResult = (_p.sent())[0];
                    return [2 /*return*/, ratResult];
                case 3:
                    e_1 = _p.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function TrackError(_a) {
    var action = _a.action, screen = _a.screen, projectKey = _a.projectKey, version = _a.version, campaignId = _a.campaignId, contentId = _a.contentId, correlationId = _a.correlationId, replacementId = _a.replacementId, selector = _a.selector, impressionId = _a.impressionId, _b = _a.ratAccountId, ratAccountId = _b === void 0 ? '' : _b, _c = _a.ratServiceType, ratServiceType = _c === void 0 ? '' : _c, _d = _a.ratServiceId, ratServiceId = _d === void 0 ? '' : _d, _e = _a.isMobile, isMobile = _e === void 0 ? false : _e, error = _a.error, _f = _a.userId, userId = _f === void 0 ? '' : _f, _g = _a.sessionId, sessionId = _g === void 0 ? '' : _g, _h = _a.domainScopedSessionId, domainScopedSessionId = _h === void 0 ? '' : _h, _j = _a.clientId, clientId = _j === void 0 ? '' : _j, ratApiAccountSrc = _a.ratApiAccountSrc, _k = _a.isPreview, isPreview = _k === void 0 ? false : _k;
    return __awaiter(this, void 0, void 0, function () {
        var obj, result;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    obj = __assign(__assign(__assign(__assign(__assign(__assign({ screen: screen, version: version, campaignId: campaignId, projectKey: projectKey, contentId: contentId, ratAccountId: ratAccountId, ratServiceType: ratServiceType, ratServiceId: ratServiceId, isMobile: isMobile, action: action, message: getError(error), userId: userId, sessionId: sessionId, domainScopedSessionId: domainScopedSessionId, clientId: clientId, ratApiAccountSrc: ratApiAccountSrc, isPreview: isPreview }, (correlationId ? { correlationId: correlationId } : {})), (campaignId ? { campaignId: campaignId } : {})), (contentId ? { contentId: contentId } : {})), (replacementId ? { replacementId: replacementId } : {})), (selector ? { selector: selector } : {})), (impressionId ? { impressionId: impressionId } : {}));
                    return [4 /*yield*/, Track(obj)];
                case 1:
                    result = _l.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
